<template>
  <b-modal
    id="bv-modal-create-linked-starts"
    title="Создать серию"
    hide-footer
    centered
  >
    <b-form @submit.prevent="createSerie">
      <b-form-group
        label="Название серии"
        label-for="serie-name"
        label-cols-sm="4"
        label-align-sm="right"
        label-size="sm"
      >
        <b-form-input
          id="serie-name"
          v-model.trim="form.name"
          required
          placeholder="Введите название"
        />
      </b-form-group>

      <b-form-group
        label="Описание"
        label-for="serie-description"
        label-cols-sm="4"
        label-align-sm="right"
        label-size="sm"
      >
        <b-form-textarea
          id="serie-description"
          v-model.trim="form.description"
          rows="3"
          placeholder="Краткое описание серии"
        />
      </b-form-group>

      <div class="text-right mt-4">
        <b-button
          variant="secondary"
          @click="$bvModal.hide('bv-modal-create-linked-starts')"
        >
          Отмена
        </b-button>
        <b-button
          variant="primary"
          class="ml-2"
          type="submit"
          :disabled="loading"
        >
          <b-spinner
            v-if="loading"
            small
            class="mr-1"
          />
          Создать
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BButton, BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'DistanceModalCreateLinkedStarts',
  components: {
    BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BButton, BSpinner,
  },
  props: {
    startId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      form: {
        name: '',
        description: '',
      },
      loading: false,
    }
  },
  methods: {
    async createSerie() {
      if (!this.form.name.trim()) {
        this.$bvToast.toast('Введите название серии', {
          title: 'Ошибка',
          variant: 'warning',
          solid: true,
        })
        return
      }

      this.loading = true
      try {
        const payload = {
          name: this.form.name,
          description: this.form.description,
          startIds: [this.startId], // сразу добавляем текущий старт
        }

        await this.$http.post('start/start-series/new-serie', payload)

        this.$bvToast.toast(`Серия "${this.form.name}" успешно создана`, {
          title: 'Успешно',
          variant: 'success',
          solid: true,
        })

        this.$bvModal.hide('bv-modal-create-linked-starts')
        this.form = { name: '', description: '' }

        this.$emit('serie-created')
      } catch (error) {
        console.error('Ошибка при создании серии:', error)
        this.$bvToast.toast('Ошибка при создании серии', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.b-form-group {
  margin-bottom: 1rem;
}

textarea {
  resize: none;
}

.b-button {
  transition: all 0.2s ease;
}

.b-button:hover {
  transform: scale(1.03);
}
</style>
